<template>
	<div class="res-filter">
		<select
			name="filterBy"
			id="filterBy"
			class="res-filter__drd"
			v-model="filter"
			@change="filterBy"
		>
			<option :value="'All'">Show All</option>
			<option v-for="(t, i) in types" :key="i" :value="t">
				Show {{ normalizeType(t) }}
			</option>
		</select>
		<span class="res-filter__count">{{ resCount }} results</span>
	</div>
</template>

<script>
import UtilityFunctions from "../../../util/classes/UtilityFunctions";
export default {
	name: "SearchResultsFilter",
	props: ["resCount"],
	data: function () {
		return {
			filter: "All",
		};
	},
	mounted() {
		this.setFilter();
	},
	computed: {
		types: function () {
			return this.$store.getters.articleTypes.filter(
				(t) => t != "INDEX_PAGE"
			);
		},
	},
	methods: {
		normalizeType: function (type) {
			return UtilityFunctions.normalizeType(type);
		},
		filterBy: function () {
			let currentPath = this.$route.path;
			let currentQuery = this.$route.query;
			this.$router.push({
				path: currentPath,
				query: {
					...currentQuery,
					filterType: this.filter,
				},
			});
		},
		setFilter: function () {
			this.filter = this.$route.query.filterType || 'All';
		},
	},
};
</script>

<style scoped>

	.res-filter {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 2rem;
	}

	.res-filter__count {
		font-weight: normal;
	}

	.res-filter__drd {
		position: relative;
		display: flex;
		align-items: center;
		border: 2px solid var(--clr-neutral-shade-3);
		padding: 0.7em 1em;
		border-radius: 0.5em;
		outline: none;
	}

	.res-filter__drd:focus {
		border-color: var(--clr-accent-primary);
	}

</style>